import React, { useContext, useEffect } from 'react';
import Explorer from './FileManager';
import { Container, Typography } from '@mui/material';

//Import Components
import { ThemeContext } from "../../../context/ThemeContext";


const BoxIndex = () => {

    const {
        changeBackground,
        changeSideBarStyle,
        chnageSidebarColor,
        changeNavigationHader
    } = useContext(ThemeContext);
    useEffect(() => {
        changeBackground({ value: "light", label: "Light" });
        changeSideBarStyle({ value: "mini", label: "Mini" });
        chnageSidebarColor("color_3");
        changeNavigationHader("color_3");
    }, []);

    return (
        <>
            <Explorer />
        </>
    );
}

export default BoxIndex;